<ng-container *ngIf="blockStatus !== null">
  <div *ngIf="blockStatus.isLocked" class="block-status block-status--locked">
    <i class="pi pi-lock block-status__icon"></i>
    <span class="block-status__user">
      <ng-container *ngIf="blockStatus.lockedBy?.id === currentUserId; else otherUser">
        {{ 'FASCICLE.LOCKED_BY_YOU' | translate }}
      </ng-container>
      <ng-template #otherUser>
        {{ blockStatus.lockedBy?.id }}
      </ng-template>
    </span>
    <span class="block-status__time" *ngIf="blockStatus.lockedAt">
      {{ blockStatus.lockedAt | date:'HH:mm' }}
    </span>
    <p-button
      *ngIf="canUnblock"
      icon="pi pi-unlock"
      severity="warning"
      [text]="true"
      size="small"
      [pTooltip]="'FASCICLE.UNLOCK' | translate"
      (onClick)="forceUnblock.emit(fascicle)"
    />
    <p-button
      *ngIf="!canUnblock"
      icon="pi pi-question-circle"
      severity="secondary"
      [text]="true"
      size="small"
      [pTooltip]="'FASCICLE.REQUEST_UNLOCK' | translate"
      (onClick)="requestUnblock.emit(fascicle)"
    />
  </div>
</ng-container>
